import React from "react";
import { Route, Routes } from "react-router-dom";

import Dashboard from "./page/dashboard/Dashboard";
import LoginPage from "./page/login/Login";
import { AuthGuard } from "./guards/AuthGuard";
import { GuestGuard } from "./guards/GuestGuard";
import Signout from "./page/signout/Signout";
import CreateBrand from "./page/brand/CreateBrand";
import BrandPortal from "./page/brand/BrandPortal";
import CreateFamily from "./page/family/CreateFamily";
import FamilyPortal from "./page/family/FamilyPortal";
import ModelPortal from "./page/model/ModelPortal";
import CreateModel from "./page/model/CreateModel";
import FirmwarePortal from "./page/firmware/FirmwarePortal";
import CreateFirmware from "./page/firmware/CreateFirmware";
import FilePortal from "./page/file/FilePortal";
import CreateFile from "./page/file/CreateFile";
import TemplatePortal from "./page/template/TemplatePortal";
import CreateTemplate from "./page/template/CreateTemplate";

function App() {
  return (
    <Routes>
      <Route path="/signout" element={<Signout />} />
      <Route
        path="/"
        element={<GuestGuard />}
        children={
          <>
            <Route path="/login" element={<LoginPage />} />
          </>
        }
      />

      <Route
        path="/"
        element={<AuthGuard />}
        children={
          <>
            <Route path="/" element={<Dashboard />} index />
            <Route path="/provisioning/brand" element={<BrandPortal />} />
            <Route path="/provisioning/brand/:type" element={<CreateBrand />} />
            <Route path="/provisioning/family" element={<FamilyPortal />} />
            <Route
              path="/provisioning/family/:type"
              element={<CreateFamily />}
            />
            <Route path="/provisioning/model" element={<ModelPortal />} />
            <Route path="/provisioning/model/:type" element={<CreateModel />} />
            <Route path="/provisioning/firmware" element={<FirmwarePortal />} />
            <Route
              path="/provisioning/firmware/:type"
              element={<CreateFirmware />}
            />
            <Route path="/provisioning/file" element={<FilePortal />} />
            <Route path="/provisioning/file/:type" element={<CreateFile />} />
            <Route path="/provisioning/template" element={<TemplatePortal />} />
            <Route
              path="/provisioning/template/:type"
              element={<CreateTemplate />}
            />
          </>
        }
      />
    </Routes>
  );
}

export default App;
